define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var Goals = require('web-agent-assets-js/lpGoals');
    var lpBaseInfoController = require('web-agent-assets-js/lpBaseInfoController');

    lpTag.lpGoalsController = function (model) {
        this.applicationType = "lpGoalsController";
        var logger = WebAgentLogger.getLogger(this.applicationType);

        var goalsApi;

        this.getGoal = function (data) {
            getGoal(data);
        };

        this.getSingleGoalObject = function (goalObject, name) {
            return getSingleGoalObject(goalObject, name);
        };
        initializeApi();

        function initializeApi() {
            goalsApi = new Goals();
        }

        /////////////////////////////// GOAL DATA ///////////////////////////////////

        function getGoal(data) {
            logger.info("","getGoal", data);
            var id;
            if (data) {
                id = data.id;
            }
            if (id) {
                var requestObj = {
                    success: lpUtils.callbackContextWrapper(handleGoalsSuccess, data),
                    error: lpUtils.callbackContextWrapper(handleGoalsError, data),
                    context: data
                };
                goalsApi.getGoal(requestObj, id);
            }
        }

        function handleGoalsSuccess(data) {
            logger.info("Goals return as Success", "handleGoalsSuccess");
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpTag.lpGoalsController.prototype.handleACRequestSuccess(model, data, lpTag.lpGoalsController.prototype.serviceNames.goals, getSingleGoalObject, context, dataObject);
        }

        function handleGoalsError(data) {
            logger.error("", "handleGoalsError", data);
            logger.graph({name: 'handleGoalsError'});
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpTag.lpGoalsController.prototype.handleRequestError(model, data, lpTag.lpGoalsController.prototype.serviceNames.goals, data && data.visitorId, dataObject);
        }

        function getSingleGoalObject(goalObject, name) {
            var toReturn = lpTag.lpGoalsController.prototype.getDataFromModelIfNotModified(model, this, name) || {
                    id: goalObject.id,
                    description: goalObject.description,
//            type : goalObject.type,
                    name: goalObject.name
                };
            var visitorId = goalObject.visitorId || (goalObject.dataObject && goalObject.dataObject.data && goalObject.dataObject.data.visitorId);
            lpTag.lpGoalsController.prototype.addToVisitorInfoById(model, 'goal', toReturn, visitorId, goalObject && goalObject.dataObject, lpTag.lpGoalsController.prototype.serviceNames.goals);
            return toReturn;
        }
    };
    lpTag.lpGoalsController.prototype = new lpBaseInfoController();

    return lpTag.lpGoalsController;

});
